
    $(document).ready(function () {

        ////round cities
        //var cw1 = $('.cities').width();
        //var cw2 = $('.display-city').width();

        //$('.cities').height(cw1);
        //$('.display-city').height(cw2);


        ////masonry grid
        //$('.grid').masonry({
        //    // set itemSelector so .grid-sizer is not used in layout
        //    itemSelector: '.masonry-brick',
        //    // use element for option
        //    columnWidth: '.grid-sizer',
        //    gutter: '.gutter-sizer',
        //    percentPosition: true
        //});

    });

